/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PriceGroupItemsListPaginatedSummary {
  /**
   * Total items count
   */
  total_rows_count?: number;
}
